<template>
    <div class="email-list">
        <IntegratedListView
            :model-value="modelValue"
            :title="title"
            :input-placeholder="inputPlaceholder"
            :empty-message="emptyMessage"
            @update:model-value="handleUpdate"
        />
        <!-- Error message for invalid email -->
        <p v-if="emailError" class="text-xs text-red-600 dark:text-red-400 mt-1">
            {{ emailError }}
        </p>
    </div>
</template>

<script>
import { ref } from 'vue';
import IntegratedListView from './IntegratedListView.vue';

export default {
    name: 'EmailListView',
    components: {
        IntegratedListView
    },
    props: {
        modelValue: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            default: 'E-mails'
        },
        inputPlaceholder: {
            type: String,
            default: 'Digite um email e pressione Enter'
        },
        emptyMessage: {
            type: String,
            default: 'Nenhum email adicionado'
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const emailError = ref('');

        const validateEmail = (email) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        };

        const handleUpdate = (newValue) => {
            // Get the newly added item (last item in the array)
            if (newValue.length > props.modelValue.length) {
                const newItem = newValue[newValue.length - 1];
                const email = newItem.name.trim().toLowerCase();

                // Validate email format
                if (!validateEmail(email)) {
                    emailError.value = 'Por favor, insira um email válido.';
                    setTimeout(() => {
                        emailError.value = '';
                    }, 3000);
                    return; // Don't emit update, reject invalid email
                }

                // Check for duplicates (case-insensitive)
                const isDuplicate = props.modelValue.some(
                    item => item.name.toLowerCase() === email
                );

                if (isDuplicate) {
                    emailError.value = 'Este email já foi adicionado.';
                    setTimeout(() => {
                        emailError.value = '';
                    }, 3000);
                    return; // Don't emit update, reject duplicate
                }

                // Update the email to lowercase
                newItem.name = email;
            }

            // Clear any previous errors
            emailError.value = '';

            // Emit the validated update
            emit('update:modelValue', newValue);
        };

        return {
            emailError,
            handleUpdate
        };
    }
};
</script>

<style scoped>
.email-list {
    /* Additional styles if needed */
}
</style>
